<template>
	<div class="import-wrapper">
		<el-tabs type="card" class="import-nav">
			<el-tab-pane>
				<span slot="label" :class="['import-tab', { error: invalidProvider.length > 0}]">
					<h5>{{ invalidProvider.length }}</h5>
					<span class="tabPaneHeading">Patients with Missing Doctor</span>
				</span>

				<PatientRows 
					v-if="invalidProviderFlag.length > 0"
					:patients="invalidProviderFlag"
					:column="column"
					row-component-type="PatientEmail">
				</PatientRows>
				<p v-else
					class="noPatients">
					No patients in this category
				</p>

			</el-tab-pane>
			<el-tab-pane>
				<span slot="label" :class="['import-tab', { error: incorrectInvalidPatient.length > 0 }]">
					<h5>{{ incorrectInvalidPatient.length }}</h5>
					<span class="tabPaneHeading">Patient with Invalid / Missing Email</span>
				</span>
				
				<template				
					v-if="invalidPatient.length > 0">
					<PatientEmail
						v-for="(importPatient, index) in invalidPatient"
						v-bind:patient="importPatient"
						v-bind:column="column"
						:index="index + 1"
						:confirm="false"
						:key="index">
					</PatientEmail>
				</template>
				<p v-else
					class="noPatients">
					No patients in this category
				</p>

			</el-tab-pane>
			<el-tab-pane>
				<span slot="label" class="import-tab">
					<h5>{{ newPatient.length }}</h5>
					<span class="tabPaneHeading">New Patients</span>
				</span>
				
				<PatientRows 
					v-if="newPatient.length > 0"
					:patients="newPatient"
					:column="column"
					row-component-type="PatientEmail">
				</PatientRows>
				<p v-else
					class="noPatients">
					No patients in this category
				</p>

			</el-tab-pane>
			<el-tab-pane>
				<span slot="label" class="import-tab">
					<h5>{{ existingPatient.length }}</h5>
					<span class="tabPaneHeading">Existing Patients</span>
				</span>
				
				<PatientRows
					v-if="existingPatient.length > 0"
					:patients="existingPatient"
					:column="column"
					row-component-type="PatientEmail">
				</PatientRows>
				<p v-else
					class="noPatients">
					No patients in this category
				</p>

			</el-tab-pane>
		</el-tabs>
		
	</div>
</template>

<script>
import ImportTable from '.'

export default {
	name: 'confirm-contact-import-table',
	extends: ImportTable,

	data() {
		return {
			showNewPatients: false,
			showExistingPatients: false,
			showInvalidProviderPatients: false,
			showInvalidPatients: false
		}
	},
	
	mounted() {
		this.$emit('totalEventCount', this.totalEventCount)
	},
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>

<style scoped>
.import-wrapper >>> .el-tabs__header {
	background-color: #f8f8f8;
}
.import-wrapper >>> .el-tabs__item.is-active {
	background-color: #ffffff;
	border: 1px solid #e4e7ed !important;
	border-bottom: 1px solid #e4e7ed !important;
	top: 2px;
}
.import-wrapper >>> .el-tabs__nav {
	border: none !important;
}
.import-wrapper >>> .el-tabs__item {
	border: none !important;
}
.import-wrapper >>> .patient {
	padding-left: 14px;
} 
.noPatients {
	color: #666666;
	font-size: 16px;
	padding: 20px;
}

/* fix tab width */
.import-wrapper >>> #tab-0 {
	min-width: 289px
}
.import-wrapper >>> #tab-1 {
	min-width: 333px
}
.import-wrapper >>> #tab-2 {
	min-width: 177px
}
.import-wrapper >>> #tab-3 {
	min-width: 203px
}
</style>
